import { motion } from "framer-motion";
import { ServiceForm } from "./ServiceForm";
import { ChevronDown } from "lucide-react";
import video from "../assets/video/Video.mp4";

const Hero = () => {
  const handleScroll = () => {
    const servicesSection = document.getElementById("services-section");
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
        <div className="min-h-[95vh] w-full flex items-center justify-center p-4 font-sans relative overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 h-full w-full object-cover z-0"
        poster="placeholder-image.jpg"
      >
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="absolute inset-0 bg-black/60 z-10"></div>

   <main className="relative z-20 w-full max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
  <motion.div
    initial={{ opacity: 0, x: -50 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
    className="p-4 md:p-8 text-white lg:text-left flex flex-col items-start -mt-64"
  >
    <h1
      className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4 text-left"
      style={{ textShadow: "0 3px 15px rgba(0,0,0,0.7)" }}
    >
      Drone Planet: Shaping the Future of Flight
    </h1>
    <p
      className="text-lg md:text-xl text-gray-200 max-w-lg mb-8 text-left"
      style={{ textShadow: "0 2px 8px rgba(0,0,0,0.7)" }}
    >
      Elevate your experience with premium drones, expert training, and endless career opportunities in the sky.
    </p>

    <motion.button
  onClick={handleScroll}
  className="flex items-center justify-center gap-2 px-12 py-3 font-bold rounded-lg border border-white text-white transition-all duration-300 bg-transparent hover:bg-white/10"
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
>
  Explore Our Services
  <ChevronDown className="w-5 h-5" />
</motion.button>


  </motion.div>

  <ServiceForm />
</main>

    </div>
  );
};

export default Hero;